import sancionesExpedientedService from '@/services/sancionesExpediente.service.js';

export default {
  namespaced: true,
  state: {
    expediente: null,
  },
  mutations: {
    setExpediente(state, expediente) {
      state.expediente = expediente;
    },
  },
  actions: {
    async fetchExpediente({ commit }, id) {
      try {
        commit('setExpediente', null);
        const response = await sancionesExpedientedService.fetchExpediente(id);
        const { data = {} } = response?.data;

        commit('setExpediente', data);

        return response;
      } catch (error) {
        console.error('Error el expediente:', error);
        commit('setExpediente', null);
      }
    },
  },
};
